import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { AiOutlineCalendar } from "react-icons/ai";

let RetornarButton = (props) => {
  return (
    <Tooltip title="Retornar a confirmar fecha ingreso">
      <IconButton aria-label="Return" onClick={() => props.onClick()}>
        <AiOutlineCalendar />
      </IconButton>
    </Tooltip>
  );
};

export default RetornarButton;
